module.exports = __webpack_public_path__ + "static/media/tc.30b3889e.png";